export const loginColors = {
  navy: "#0F4565",
  text: "#10243E",
  teal: "#0C8A80",
  tealHover: "#08746C",
  softTeal: "#E8F5F3",
  page: "#F4F7FA",
  panelTop: "#F8FAFC",
  panelBottom: "#F3F7FA",
  card: "#FFFFFF",
  border: "#DCE3EA",
  cardBorder: "#E0E6EC",
  muted: "#66758A",
  input: "#FBFCFD",
};

export const loginType = {
  fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  systemTitle: { fontSize: 23, fontWeight: 700, lineHeight: 1.25 },
  heading: { fontSize: 30, fontWeight: 700, lineHeight: 1.2 },
  supporting: { fontSize: 15, fontWeight: 400, lineHeight: 1.5 },
  input: { fontSize: 15, fontWeight: 400, lineHeight: 1.5 },
  button: { fontSize: 15, fontWeight: 600, lineHeight: 1.4 },
};
